import describeCondition from '../../../model/condition/describe.js'

/**
 * Writes a readable one-line form of a stored condition to a text field.
 *
 * Config shape:
 * {
 *     logicType: 'calcFields',
 *     operationType: 'header.describeCondition',
 *     sourceField: 'match',
 *     rowsArray: 'conditions',     // optional
 *     targetField: 'matchText'
 * }
 *
 * With `rowsArray`, a record that has rows is described from their display
 * names — "Location is not Outside the EU" rather than "locationClass ≠ nonEu"
 * — since those are what the person picked. The rows are also what `match` was
 * built from, so the two cannot disagree. A record without rows falls back to
 * describing the stored condition itself.
 *
 * Derived on every save, so the text cannot drift from the condition it
 * describes. An absent or empty condition writes '' — a condition that holds
 * for everything — and the display decides how to say that.
 */
const headerDescribeCondition = (data, operation) => {
    const { sourceField, rowsArray, targetField } = operation
    if (!sourceField || !targetField) return data

    const rows = rowsArray ? data?.[rowsArray] : undefined
    if (Array.isArray(rows)) {
        const text = rows
            .filter(r => r && r.field && r.operator)
            .map(r => [r.fieldName || r.field, r.operatorName || r.operator, r.valueName || r.value]
                .filter(p => p !== undefined && p !== null && p !== '').join(' '))
            .join(' & ')
        return { ...data, [targetField]: text }
    }
    return { ...data, [targetField]: describeCondition(data?.[sourceField]) }
}

export default headerDescribeCondition
